// extracted by mini-css-extract-plugin
export default {"statHeading":"SummaryTab_statHeading__cq-Bs","statTable":"SummaryTab_statTable__kZl-F","editColumn":"SummaryTab_editColumn__H81KM"};